/**
 * @Author: lifuzhao
 * @Date: 2019-07-20
 * @Project: driver
 */
import Vue from 'vue'

const _bus = new Vue()
_bus.install = function (Vue) {
  Vue.prototype.$bus = Vue.prototype.bus = _bus
}
export default _bus